import { BaseButton } from "../../../../../components/Button/BaseButton.tsx";
import { ThumbnailContent } from "../../../../../components/Content/ThumbnailContent.tsx";
import { Icon } from "../../../../../components/Icon/Icon.tsx";
import type { StyleModelImagesKind } from "../../../../types.ts";

const StyleImageKingThumbnail = ({ src }: { src: string }) => (
  <div className="w-1600 h-1600 rounded-100 overflow-clip border-input-border-width">
    <ThumbnailContent
      resourceType="IMAGE"
      className="w-full h-full"
      src={src}
    />
  </div>
);

const STYLE_KIND_OPTIONS: Record<
  StyleModelImagesKind,
  { footer: React.ReactElement | null; title: string; description: string }
> = {
  PHOTOGRAPHY: {
    footer: (
      <div className="flex-row-center w-full">
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/photography_1.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/photography_2.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/photography_3.png" />
      </div>
    ),
    title: "Photography",
    description: "Realistic pictures from the real world",
  },
  ILLUSTRATION_2D: {
    footer: (
      <div className="flex-row-center w-full">
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/illustration_1.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/illustration_2.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/illustration_3.png" />
      </div>
    ),
    title: "2D Illustration",
    description: "Artworks representing objects, or concepts",
  },
  GRAPHIC_3D: {
    footer: (
      <div className="flex-row-center w-full">
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/3D_1.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/3D_2.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/3D_3.png" />
      </div>
    ),
    title: "3D Graphic",
    description: "Computer-generated images",
  },
  ICON: {
    footer: (
      <div className="flex-row-center w-full">
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/icon_1.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/icon_2.png" />
        <StyleImageKingThumbnail src="https://storage.googleapis.com/419c45cf-be8a-4cba-bbcd-74a221eb2587/app/assets/onboarding/images_kind/icon_3.png" />
      </div>
    ),
    title: "Icon",
    description: "A symbol of a brand or a pictogram",
  },
  OTHER: {
    footer: null,
    title: "Other",
    description: "If nothing fits in the previous categories",
  },
};

export const StyleImageKindSelectorContent = ({
  onKindSelect,
}: {
  onKindSelect: (kind: StyleModelImagesKind) => void;
}) => (
  <div className="flex-col gap-200 p-400 w-[680px]">
    <div className="grid grid-cols-2 gap-200">
      {Object.entries(STYLE_KIND_OPTIONS).map(([kind, option]) => (
        <BaseButton
          key={kind}
          onClick={() => {
            onKindSelect(kind);
          }}
          className="p-300 rounded-400 border hover:border-primary-hover hover:bg-surface-primary-hover"
        >
          <div className="flex-col gap-200 h-full">
            <div className="flex-col gap-200">
              <div className="flex-row items-center justify-between">
                <div className="body-lg-semibold text-primary">
                  {option.title}
                </div>
                <Icon
                  name="ChevronRight"
                  size="sm"
                  className="fill-secondary"
                />
              </div>
              <div className="body-md-default text-secondary">
                {option.description}
              </div>
            </div>
            {option.footer}
          </div>
        </BaseButton>
      ))}
    </div>
  </div>
);
